import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core'
import { ApiService } from '../api.service'
import { Subscription } from 'rxjs'
import Swal from 'sweetalert2'

@Component({
	selector: 'nodes-text-search',
	templateUrl: './nodes-text-search.component.html',
	styleUrls: ['./nodes-text-search.component.scss']
})

export class NodesTextSearchComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	loading = false
	error = false
	nodesTextSearching = false
	nodesTextSearchSuccess = false
	nodesTextSearchError = false

	@Input() course = 0
	text = ''
	nodesSearch: any[] = []
	nodesSearchResults: any[] = []

	@Output() onClose: EventEmitter<boolean> = new EventEmitter

	nodesTextSearchSub = new Subscription
	showHeadingSub = new Subscription

	constructor(private dataService: ApiService) {}
	
	ngOnInit(): void {
		// this.loading = true
		// this.nodes.includes()
	}

	ngAfterViewInit(): void {
		
	}

	ngOnChanges(): void {
		// this.getNodes()
	}

	ngOnDestroy(): void {
		this.nodesTextSearchSub?.unsubscribe()
	}

	updateNodes() {
		this.nodesSearch = []
		let checkboxes = document.querySelectorAll('input[type="checkbox"][name="nodes-search"]:checked')
		checkboxes.forEach((checkbox: any) => {
			// console.log(checkbox)
			let val = checkbox.value
			if (!this.nodesSearch.includes(val)) this.nodesSearch.push(val)
		})

		console.log(this.nodesSearch)
	}

	nodesTextSearch() {
		console.log(this.text)
		console.log(this.nodesSearch)

		if (this.text == '') {
			Swal.fire('Error', 'Por favor, introduzca un texto para buscar.', 'error')
			return
		}

		if (this.nodesSearch.length == 0) {
			Swal.fire('Error', 'Por favor, seleccione en qué nodos se buscará', 'error')
			return
		}


		this.nodesTextSearching = true
		this.nodesTextSearchSuccess = false
		this.nodesTextSearchError = false

		this.nodesTextSearchSub = this.dataService.nodesTextSearch(this.course, this.nodesSearch, this.text)
		.subscribe(
			data => {
				console.log(data)
				this.nodesTextSearching = false
				this.nodesTextSearchSuccess = true
				this.nodesTextSearchError = false
				this.nodesSearchResults = data
			},
			error => {
				console.log(error)
				this.nodesTextSearching = false
				this.nodesTextSearchSuccess = false
				this.nodesTextSearchError = true
			},
		)
	}

}
